// extracted by mini-css-extract-plugin
module.exports = {"box":"logo_box__3U0mM","item_img_yandex":"logo_item_img_yandex__3Bg1B","item_img_mail":"logo_item_img_mail__1hULw"};